import selectEvent from '%evp_ticket_frontend/js/redux/currentEvent/selectors/selectEvent';
import { openSnackbar, VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import Translator from '%app/js/common/services/translator';
import hallManager from '%paysera_seat_selection_integration/js/seatings/Page/components/SeatingMap/service/HallManager';
import setSectors from './setSectors';

function initializeSectors() {
    return async (dispatch, getState) => {
        const event = selectEvent(getState());
        if (!event) {
            return;
        }

        try {
            const sectors = await hallManager.getSectors(event.token);
            dispatch(setSectors({
                sectors,
            }));
        } catch (error) {
            if (error.response && error.response.status < 500) {
                dispatch(openSnackbar({
                    variant: VARIANT_ERROR,
                    message: Translator.trans(error.response.data.error_description),
                }));
            } else {
                throw error;
            }
        }
    };
}

export default initializeSectors;
